import { useState } from "react";
import { useWorkDayApi } from "~/WorkDayApi";

type DeleteExpenseState = {
  deleteLoading: boolean;
  deleteExpenseEntry: (expenseId: string) => Promise<void>;
};

export function useDeleteExpense(): DeleteExpenseState {
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const { deleteExpense } = useWorkDayApi();

  const deleteExpenseEntry = async (expenseId: string) => {
    setDeleteLoading(true);
    try {
      await deleteExpense({ expenseId });
    } finally {
      setDeleteLoading(false);
    }
  };

  return { deleteLoading, deleteExpenseEntry };
}
